import useGetPrizes from './useGetPrizes';
import useGetMyPrizes from './useGetMyPrizes';
import useGetStatus from './useGetStatus';
import useIsPending from './useIsPending';

export default function useFullProps() {
  const prizes = useGetPrizes();
  const myPrizes = useGetMyPrizes();
  const status = useGetStatus({ myPrizes });
  const isPending = useIsPending();
  return { prizes, myPrizes, status, isPending };
}
